import React, { Fragment, useState } from 'react';
import { FaCheck, FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import EditList from './EditList';
import { formatDate } from 'utils/helpers';
import { RiCloseLine } from 'react-icons/ri';
import {useQueryClient } from 'react-query';

const ViewList = ({ vendor, index, getData,setModalType,approvedUpdateVendor,setApprovedUpdateVendor,setSelectedVendorId }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  
  const currentUser = useSelector((state) => state.user.currentUser);
  
  return (
    <Fragment>
      <tr key={vendor._id} className={`${index % 2 !== 0 && 'bg-gray-100'}`}>
        <TD>{index}</TD>
        <TD>{vendor.vendorName}</TD>
        <TD>{vendor.vendorCode ?? 10}</TD>
        <TD>{vendor.status}</TD>
        <TD>{vendor.effectiveDate ? formatDate(vendor.effectiveDate): "--"}</TD>
        <TD>{vendor.expiryDate ? formatDate(vendor.expiryDate): "--"}</TD>
        <TD>
          {vendor.createdAt ? formatDate(vendor.createdAt) : ''}
        </TD>

        <TD>
          {checkPermission([permissions.manage_masters], currentUser) ? (
            <div className="flex items-center space-x-2">
              <button
                onClick={() => setShowViewModel(true)}
                className="p-1 text-center justify-center flex m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white h-7 items-center  w-8"
              >
                <FaEye />
              </button>
              {vendor.status == "Approved" && <button
                onClick={() => setShowEditModal(true)}
                className="p-1 text-center justify-center flex rounded-md bg-blue-500 hover:bg-blue-600 text-white h-7 items-center  w-8"
                title="Edit Vendor"
              >
                <FaEdit />
              </button>}


              {!(vendor.status == "Approved" || vendor.status == "Rejected") ? 
              <div className='flex flex-row'>
                <button
                className="p-1 text-center justify-center flex m-1 bg-green-500 hover:bg-green-600 shadow-none font-bold rounded-md text-white text-md h-7 items-center  w-8"
                onClick={() => {
                  setSelectedVendorId(vendor._id);
                  setModalType("approval");
                }}
              >
                <FaCheck 
                onClick={() => {
                  setSelectedVendorId(vendor._id);
                  setModalType("approval"); 
                }}
                />
              </button>

              <button
                className="p-1 justify-center flex m-1 bg-red-500 hover:bg-red-600 text-lg shadow-none font-bold rounded-md text-white text-md text-center h-7 items-center  w-8"
                onClick={() => {
                  setSelectedVendorId(vendor._id)
                  setModalType("reject");
                }}
              >
                <RiCloseLine />
              </button>
              </div>: <></>}

            </div>
          ) : (
            <p>No Actions Available</p>
          )}
        </TD>

      </tr>
      {showViewModel && (
        <EditList
        approvedUpdateVendor={approvedUpdateVendor}
        vendor={vendor}
          desable={true}
          handleClick={() => {setShowViewModel(false);
          }}
          showViewModel={showViewModel}
          setApprovedUpdateVendor={setApprovedUpdateVendor}
        />
      )}
      {showEditModal && (
        <EditList
        approvedUpdateVendor={approvedUpdateVendor}
        vendor={vendor}
          handleClick={() => {setShowEditModal(false);
            getData();
          }}
          showEditModal={showEditModal}
          setApprovedUpdateVendor={setApprovedUpdateVendor}
        />
      )}
    </Fragment>
  );
};

export default ViewList;
